module.exports = __webpack_public_path__ + "static/media/SolitaireStory.6cd79ed5.png";